module.exports = {"title":"Press Challenge | Tipping Service | Racing Post","meta":[{"name":"description","content":"Compare top tipsters' horse racing predictions from across various publications with records for the current year as well as the monthly record."}]}


//////////////////
// WEBPACK FOOTER
// ./src/js/pressChallenge/meta.json
// module id = 2293
// module chunks = 0